import consumer from "./consumer"

let subscription
let cleanup
function initializeNotifications() {
  if (cleanup) cleanup()
  if (subscription) { consumer.subscriptions.remove(subscription); subscription = null }
  const root = document.getElementById("admin-notifications")
  if (!root) return
  const button = document.getElementById("admin-notifications-toggle")
  const panel = document.getElementById("admin-notifications-panel")
  const badge = document.getElementById("admin-notifications-count")
  let active = true
  let requestNumber = 0
  let loadingMore = false
  const fetchList = url => fetch(url, {credentials: "same-origin", headers: {Accept: "text/html"}})
    .then(response => {
      if (!response.ok) throw new Error("Unable to load notifications")
      return response.text()
    })
  const refresh = () => {
    const number = ++requestNumber
    loadingMore = false
    fetchList(root.dataset.url)
      .then(html => {
        if (!active || number !== requestNumber) return
        panel.innerHTML = html
        const count = Number(panel.querySelector("[data-unread-count]").dataset.unreadCount)
        badge.textContent = count > 99 ? "99+" : String(count)
        badge.hidden = count === 0
        button.setAttribute("aria-label", `Document notifications, ${count} unread`)
      })
      .catch(() => {
        if (active && number === requestNumber) panel.textContent = "Notifications could not load. Close and reopen to retry."
      })
  }
  const loadMore = () => {
    const content = panel.querySelector("[data-next-url]")
    const url = content && content.dataset.nextUrl
    if (loadingMore || !url) return
    loadingMore = true
    const number = requestNumber
    const link = panel.querySelector("[data-notification-page]")
    if (link) { link.textContent = "Loading…"; link.setAttribute("aria-disabled", "true") }
    fetchList(url).then(html => {
      if (!active || number !== requestNumber) return
      const template = document.createElement("template")
      template.innerHTML = html
      const next = template.content.querySelector("[data-next-url]")
      const list = panel.querySelector(".admin-notification-list")
      template.content.querySelectorAll(".admin-notification-item").forEach(item => list.appendChild(item))
      content.dataset.nextUrl = next.dataset.nextUrl || ""
      const footer = panel.querySelector(".admin-notification-pagination")
      if (footer) footer.remove()
      const nextFooter = template.content.querySelector(".admin-notification-pagination")
      if (nextFooter) content.appendChild(nextFooter)
    }).catch(() => {
      if (active && number === requestNumber && link) link.textContent = "Retry loading more"
    }).finally(() => {
      if (number === requestNumber) {
        loadingMore = false
        if (link) link.removeAttribute("aria-disabled")
      }
    })
  }
  const paginate = event => {
    if (!event.target.closest("[data-notification-page]")) return
    event.preventDefault()
    loadMore()
  }
  const scroll = event => {
    const list = event.target
    if (!list.classList.contains("admin-notification-list")) return
    if (list.scrollHeight - list.scrollTop - list.clientHeight < 40) loadMore()
  }
  panel.addEventListener("click", paginate)
  panel.addEventListener("scroll", scroll, true)
  const close = () => { panel.hidden = true; button.setAttribute("aria-expanded", "false") }
  const toggle = () => {
    panel.hidden = !panel.hidden
    button.setAttribute("aria-expanded", String(!panel.hidden))
    if (!panel.hidden) refresh()
  }
  const outside = event => { if (!root.contains(event.target)) close() }
  const escape = event => { if (event.key === "Escape" && !panel.hidden) { close(); button.focus() } }
  button.addEventListener("click", toggle)
  document.addEventListener("click", outside)
  document.addEventListener("keydown", escape)
  subscription = consumer.subscriptions.create("AdminNotificationsChannel", {connected: refresh, received: refresh})
  refresh()
  cleanup = () => {
    active = false
    close()
    panel.removeEventListener("click", paginate)
    panel.removeEventListener("scroll", scroll, true)
    button.removeEventListener("click", toggle)
    document.removeEventListener("click", outside)
    document.removeEventListener("keydown", escape)
    cleanup = null
  }
}
document.addEventListener("turbolinks:load", initializeNotifications)
document.addEventListener("turbolinks:before-cache", () => {
  if (cleanup) cleanup()
  if (subscription) { consumer.subscriptions.remove(subscription); subscription = null }
})
